import axios from "axios";

const server_address = process.env.REACT_APP_SERVER_ADDRESS;
const API = axios.create({ baseURL: `${server_address}` });
// const API = axios.create( {baseURL: 'https://edscalateserver.onrender.com'}) ;

// A function that will happen on each of our requests -- adds token so backend knows who it is.
API.interceptors.request.use((req) => {
  if (localStorage.getItem("profile")) {
    req.headers.authorization = `Bearer ${JSON.parse(localStorage.getItem("profile")).token}`;
  }
  return req;
});

// Returns all the courses in the database
export const fetchCourse = (id) => API.get(`/courses/${id}`);
export const fetchCourses = (page) => API.get(`/courses?page=${page}`);
export const fetchCoursesBySearch = (searchQuery) =>
  API.get(`/courses/search?searchQuery=${searchQuery}`);
export const fetchPrerequisites = (searchQuery) =>
  API.get(`/courses/prereq?searchQuery=${searchQuery}`);
export const createCourse = (newPost) => API.post("/courses", newPost);
export const updateCourse = (id, updatedPost) =>
  API.patch(`/courses/${id}/update`, updatedPost);
export const deleteCourse = (id) => API.delete(`/courses/${id}/delete`);

// User info
export const signin = (formData) => API.post("/user/signin", formData);
export const signup = (formData) => API.post("/user/signup", formData);
export const signuporingoogle = (formData) =>
  API.post("/user/signuporingoogle", formData);
export const updateUserCourseTaken = (id, courseTaken) =>
  API.patch(`/user/updateUserCourseTaken/${id}`, courseTaken);
export const addtonewsletter = (formData) =>
  API.post("/user/addtonewsletter", formData);
export const addtowaitlist = (formData) =>
  API.post("/user/addtowaitlist", formData);
export const forgotpassword = (email) =>
  API.post("/user/forgotpassword", email);
export const resetpassword = (token, formData) =>
  API.patch(`/user/resetpassword/${token}`, formData);

// Returns content and user position in the content (patch as may update user position)
export const fetchCurrentContent = (courseID, user_id) =>
  API.patch(`/learn/${courseID}`, user_id);
export const fetchContent = (contentID) => API.get(`/editcontent/${contentID}`);
export const updateContent = (id, content) =>
  API.patch(`/editcontent/update/${id}`, content);
export const addSubsectionToContent = (id, subsection) =>
  API.patch(`/editcontent/addsubsection/${id}`, subsection);
export const copyFrameToContent = (id, frame) =>
  API.patch(`/editcontent/copyframe/${id}`, frame);

// Adding comments and liking them
export const addComment = (id, update_comment_details) =>
  API.patch(`/comment/${id}/addCommentNew`, update_comment_details);
export const editComment = (id, update_comment_details) =>
  API.patch(`/comment/${id}/editCommentTop`, update_comment_details);
export const addCommentReply = (id, update_comment_details) =>
  API.patch(`/comment/${id}/addcommentreply`, update_comment_details);
export const editCommentReply = (id, edit_comment_details) =>
  API.patch(`/comment/${id}/editcommentreply`, edit_comment_details);
export const deleteCommentReply = (id, update_comment_details) =>
  API.patch(`/comment/${id}/deletecommentreply`, update_comment_details);
export const upDownVoteComment = (id, updownvote_comment_details) =>
  API.patch(`/comment/${id}/updownvote`, updownvote_comment_details);

// Returns course content list and content for editing
export const fetchCourseStructure = (id) =>
  API.get(`/editcoursestructure/${id}`);
export const fetchContentItems = () => API.get("/editcoursestructure/items");
export const createContent = (content) =>
  API.post(`/editcoursestructure/create`, content);
export const updateCourseContentItems = (id, updatedCourseContentItems) =>
  API.patch(`/editcoursestructure/updates/${id}`, updatedCourseContentItems);

// Update user progress
export const updateProgressContent = (contentID, content) =>
  API.patch(`/learn/${contentID}/updateProgressContent`, content);
export const updateProgressProblemsTried = (contentID, problemsTried) =>
  API.patch(`/learn/${contentID}/updateProgressProblemsTried`, problemsTried);
export const updateProgressNotes = (contentID, notes) =>
  API.patch(`/learn/${contentID}/updateProgressNotes`, notes);
export const updateProgressContentSeen = (contentID, contentSeen) =>
  API.patch(`/learn/${contentID}/updateProgressContentSeen`, contentSeen);
export const updateProgressElapsedTime = (contentID, elapsedTime) =>
  API.patch(`/learn/${contentID}/updateProgressElapsedTime`, elapsedTime);
export const updateProgressFeedback = (contentID, feedback) =>
  API.patch(`/learn/${contentID}/updateProgressFeedback`, feedback);
export const updateProgressAddHighlight = (contentID, highlight) =>
  API.patch(`/learn/${contentID}/updateProgressAddHighlight`, highlight);
export const updateProgressDeleteHighlight = (contentID, highlightId) =>
  API.patch(`/learn/${contentID}/updateProgressDeleteHighlight`, highlightId);
export const fetchAllBookmarks = () => API.get("/learn/allbookmarks");
export const updateProgressAddBookmark = (contentID, bookmark) =>
  API.patch(`/learn/${contentID}/updateProgressAddBookmark`, bookmark);
export const updateProgressEditBookmark = (contentID, bookmark) =>
  API.patch(`/learn/${contentID}/updateProgressEditBookmark`, bookmark);
export const updateProgressDeleteBookmark = (contentID, bookmarkId) =>
  API.patch(`/learn/${contentID}/updateProgressDeleteBookmark`, bookmarkId);
export const updateProgressConceptsUsed = (contentID) =>
  API.patch(`/learn/${contentID}/updateProgressConceptsUsed`);
export const updateProgressNotesUsed = (contentID) =>
  API.patch(`/learn/${contentID}/updateProgressNotesUsed`);
export const updateProgressCommentsUsed = (contentID) =>
  API.patch(`/learn/${contentID}/updateProgressCommentsUsed`);
export const updateProgressEquationsUsed = (contentID) =>
  API.patch(`/learn/${contentID}/updateProgressEquationsUsed`);

// Support
export const fetchSupportItems = () => API.get("/editsupport/items");
export const fetchSupportItemById = (id) => API.get(`/editsupport/fetch/${id}`);
export const duplicateSupportItemById = (id) =>
  API.post(`/editsupport/duplicate/${id}`);
export const deleteSupportItemById = (id) =>
  API.patch(`/editsupport/delete/${id}`);
export const updateSupportItem = (support_id, support) =>
  API.patch(`/editsupport/update/${support_id}`, support);
export const createSupportItem = (support) =>
  API.post("/editsupport/create", support);
